const OUTWARD = /^[A-Z]{1,2}\d[A-Z\d]?$/;
const INWARD = /^\d[A-Z]{2}$/;

/**
 * Return only the outward code of a UK postcode ("SE18 5PS" -> "SE18").
 * Accepts a full postcode or an outward code alone. Returns null for anything
 * that is not a recognisable UK postcode, so a bad value is dropped, never kept whole.
 */
export function outwardCode(raw: unknown): string | null {
  if (typeof raw !== "string") return null;
  const compact = raw.toUpperCase().replace(/\s+/g, "");
  if (compact.length >= 5) {
    const outward = compact.slice(0, -3);
    const inward = compact.slice(-3);
    if (INWARD.test(inward) && OUTWARD.test(outward)) return outward;
  }
  if (OUTWARD.test(compact)) return compact;
  return null;
}
